import React from "react";
import trans from "../../../../../utils";

export default function ChartItem(props) {
  return (
    <>
      <div
        className={`flex-between ${props.margin} cursor-pointer`}
        onClick={props.onClick}
      >
        <div className="flex-center">
          <div className={`${props.style} mi-8`}></div>
          <span className="fs-16 fw-400 neutral-500 mi-8">
            {trans(props.title)}
          </span>
        </div>
        <span className="fs-16 fw-500">{props.number}</span>
      </div>
    </>
  );
}
